import { Companion_getInstance3n9as6ds1py67 as Companion_getInstance } from '../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function toLineItems(_this__u8e3s4, project) {
  var seed = Companion_getInstance().m2p();
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination = LinkedHashMap().f6();
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp0_safe_receiver = element.w83_1;
    var key = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i9d(project, seed);
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination.p3(key);
    var tmp;
    if (value == null) {
      var answer = ArrayList().w();
      destination.s3(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.v(element);
  }
  var transformed = destination;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList().w();
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_0 = transformed.d2().m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element_0 = _iterator__ex2g4s_0.o1();
    var tmp0_safe_receiver_0 = element_0.e2();
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_0.v(tmp0_safe_receiver_0);
    }
  }
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination_0, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_1 = LinkedHashMap().fc(capacity);
  var _iterator__ex2g4s_1 = destination_0.m1();
  while (_iterator__ex2g4s_1.n1()) {
    var element_1 = _iterator__ex2g4s_1.o1();
    var tmp$ret$13 = element_1.k7z_1;
    destination_1.s3(tmp$ret$13, element_1);
  }
  var groups = destination_1;
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination_2 = LinkedHashMap().fc(mapCapacity(transformed.p1()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s_2 = transformed.d2().m1();
  while (_iterator__ex2g4s_2.n1()) {
    var element_2 = _iterator__ex2g4s_2.o1();
    var tmp_0 = element_2.e2();
    // Inline function 'kotlin.collections.component1' call
    var group = element_2.e2();
    // Inline function 'kotlin.collections.component2' call
    var items = element_2.f2();
    var set = group == null ? null : toLineItems$scopeSet(group, groups);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_3 = ArrayList().u(collectionSizeOrDefault(items, 10));
    var _iterator__ex2g4s_3 = items.m1();
    while (_iterator__ex2g4s_3.n1()) {
      var item = _iterator__ex2g4s_3.o1();
      var tmp$ret$19 = item.n99(project, group, set);
      destination_3.v(tmp$ret$19);
    }
    destination_2.s3(tmp_0, destination_3);
  }
  return destination_2;
}
function toLineItems$scopeSet(_this__u8e3s4, groups) {
  var tmp;
  if (_this__u8e3s4.p7z_1) {
    tmp = _this__u8e3s4;
  } else {
    // Inline function 'kotlin.collections.get' call
    var key = _this__u8e3s4.q7z_1;
    var tmp0_safe_receiver = (isInterface(groups, KtMap()) ? groups : THROW_CCE()).p3(key);
    tmp = tmp0_safe_receiver == null ? null : toLineItems$scopeSet(tmp0_safe_receiver, groups);
  }
  return tmp;
}
//region block: exports
export {
  toLineItems as toLineItems19fpah7suhbci,
};
//endregion

//# sourceMappingURL=Specification.ext.mjs.map
